module.exports = __webpack_public_path__ + "img/icomoon.9ac5974.svg";